var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { rethrowSimple } from "@/utils/simple-error";
import { CleanableSummary, CleanupResult, PaginationOptions } from "./Cleanup/model";
import { fetcher } from "@/schema";
const _fetchDiscardedDatasetsSummary = fetcher.path("/api/storage/datasets/discarded/summary").method("get").create();
export function fetchDiscardedDatasetsSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield _fetchDiscardedDatasetsSummary({});
            return new CleanableSummary(data);
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const _fetchDiscardedDatasets = fetcher.path("/api/storage/datasets/discarded").method("get").create();
export function fetchDiscardedDatasets(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            options = options !== null && options !== void 0 ? options : new PaginationOptions();
            const { data } = yield _fetchDiscardedDatasets({
                offset: options.offset,
                limit: options.limit,
                order: options.order,
            });
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const _cleanupDiscardedDatasets = fetcher.path("/api/storage/datasets").method("delete").create();
export function cleanupDiscardedDatasets(items) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const item_ids = items.map((item) => item.id);
            const { data } = yield _cleanupDiscardedDatasets({
                item_ids,
            });
            return new CleanupResult(data, items);
        }
        catch (error) {
            return new CleanupResult(undefined, items, error);
        }
    });
}
const _fetchDiscardedHistoriesSummary = fetcher.path("/api/storage/histories/discarded/summary").method("get").create();
export function fetchDiscardedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield _fetchDiscardedHistoriesSummary({});
            return new CleanableSummary(data);
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const _fetchDiscardedHistories = fetcher.path("/api/storage/histories/discarded").method("get").create();
export function fetchDiscardedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            options = options !== null && options !== void 0 ? options : new PaginationOptions();
            const { data } = yield _fetchDiscardedHistories({
                offset: options.offset,
                limit: options.limit,
                order: options.order,
            });
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const _cleanupDiscardedHistories = fetcher.path("/api/storage/histories").method("delete").create();
// TODO rename, this removes histories in general, not just discarded ones
export function cleanupDiscardedHistories(items) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const item_ids = items.map((item) => item.id);
            const { data } = yield _cleanupDiscardedHistories({
                item_ids,
            });
            return new CleanupResult(data, items);
        }
        catch (error) {
            return new CleanupResult(undefined, items, error);
        }
    });
}
const fetchArchivedHistoriesSummaryData = fetcher
    .path("/api/storage/histories/archived/summary")
    .method("get")
    .create();
export function fetchArchivedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield fetchArchivedHistoriesSummaryData({});
        return new CleanableSummary(data);
    });
}
const fetchArchivedHistoriesData = fetcher.path("/api/storage/histories/archived").method("get").create();
export function fetchArchivedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        options = options !== null && options !== void 0 ? options : new PaginationOptions();
        const { data } = yield fetchArchivedHistoriesData({
            offset: options.offset,
            limit: options.limit,
            order: options.order,
        });
        return data;
    });
}
